import axios from "./axiosInstance";

const authService = {
  login(payload) {
    //console.log("payload service section", payload);
    return axios.post("/user/login", payload);
  },
};

export default authService;
